<template>
    <div class="message-status" v-if="data?.message_status">
        <img :src="loadFile(`whatsapp/message-status/${data?.message_status}.svg`)">
    </div>
</template>

<script setup>
import { loadFile } from '@/components/utils.js'

const props = defineProps({
    data: {
        type: Object,
        default: () => ({}),
        required: true,
    },
});

</script>

<style scoped lang="scss">
.message-status{
    display: inline-flex;
}
</style>
